import ComparativeAddressDataRow from './ComparativeAddressDataRow';
import ComparativeDataCustomContent from './ComparativeDataCustomContent';
import ComparativeDataHeader from './ComparativeDataHeader';
import ComparativeDataRow from './ComparativeDataRow';
import ComparativeDataSection from './ComparativeDataSection';

export {
	ComparativeAddressDataRow,
	ComparativeDataCustomContent,
	ComparativeDataHeader,
	ComparativeDataRow,
	ComparativeDataSection,
}